import type { HeadlinePriceType } from '@phx/data-sources/medication-marketplace';

// Distinguishes a genuine incentive discount from an offer that is merely typed
// 'Incentive' or 'PharmacyIncentive' with no real price break (e.g. a dose where
// Incentive equals Cash). `savings` is expected to be computed as list/Cash price
// minus patient price (see useSelfPayPricing), which treats both 'Incentive' and
// 'PharmacyIncentive' as genuine incentive-savings offer types.
export const hasIncentiveSavings = (
    offer?:
        | { headlinePriceType?: HeadlinePriceType | string | null }
        | undefined,
    savings?: number | null
): boolean =>
    (!offer ||
        offer.headlinePriceType === 'Incentive' ||
        offer.headlinePriceType === 'PharmacyIncentive') &&
    !!savings &&
    savings > 0;
